<style>
#ModifyPermissions .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 500px !important;
}
#ModifyPermissions .v-input__slot,
#ModifyPermissions .v-text-field__slot label {
  font-size: 12px;
}
#ModifyPermissions .v-subheader {
  font-size: 12px !important;
}
#ModifyPermissions .values__list--header {
  display: flex;
}
#ModifyPermissions .v-input--selection-controls {
  margin-top: 0px;
}
#ModifyPermissions .v-messages.theme--light,
#ModifyPermissions .v-input--selection-controls__ripple {
  display: none;
}
#ModifyPermissions .v-input__slot {
  margin-bottom: 0px;
}
#ModifyPermissions .btn--text,
#ModifyPermissions .v-select__slot label {
  font-size: 12px;
}
#ModifyPermissions .btn--text:not(:last-child) {
  margin-right: 20px;
}
#ModifyPermissions .btn--radio {
  margin-right: 0px !important;
}
#ModifyPermissions .v-input--selection-controls__input {
  margin-right: 0px;
}
#ModifyPermissions .v-input--selection-controls__input i {
  font-size: 20px;
}
#ModifyPermissions .list__container--el:first-child {
  pointer-events: none;
}
#ModifyPermissions .v-input--radio-group__input,
#ModifyPermissions
  .v-input.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row.theme--light
  > div {
  justify-content: space-between;
}
#ModifyPermissions .width--fixed {
  width: 25%;
}
</style>

<template>
  <Modal
    modalName="ModifyPermissions"
    @opened="getLayers(), loadUserPermissions()"
    @saved="savePermissions"
    title="Edycja uprawnień użytkownika"
    :buttons="['save']"
  >
    <div class="wrapper">
      <ul class="values__list">
        <span
          v-for="group in permissionsList"
          :key="group.display_name"
        >
          <v-subheader>{{ group.display_name }}</v-subheader>
          <template v-for="layer in group.permissions">
            <li
              class="list__container--el"
              v-if="currentGroupPermissions[group.name]"
              :key="layer.name"
            >
              <span v-if="group.name == 'layers'" style="width:100%;">
                <v-subheader class="width--fixed">{{layer.display_name}}</v-subheader>
                <ul class="values__list">
                  <template v-for="permission in layer.permissions">
                    <li style="display: flex" :key="permission.name">
                      <span class="width--fixed">{{permission.display_name}}</span>
                      <v-radio-group
                        class="width--fixed"
                        v-for="per in permission.permissions"
                        v-model="currentGroupPermissions[group.name][layer.name][permission.name]"
                        :key="per.display_name"
                        row
                      >
                        <v-radio
                          class="btn--radio"
                          :value="per.value"
                          color="#2a579a"
                        ></v-radio>
                        <label
                          class="btn--text"
                          v-text="per.display_name"
                        ></label>
                      </v-radio-group>
                    </li>
                  </template>
                </ul>
              </span>
              <span v-else style="width:100%; display: flex">
                <span class="width--fixed">{{layer.display_name}}</span>
                <v-radio-group
                  class="width--fixed"
                  v-for="permission in layer.permissions"
                  v-model="currentGroupPermissions[group.name][layer.name]"
                  :key="permission.display_name"
                  row
                >
                  <v-radio
                    class="btn--radio"
                    :value="permission.value"
                    color="#2a579a"
                  ></v-radio>
                  <label
                    class="btn--text"
                    v-text="permission.display_name"
                  ></label>
                </v-radio-group>
              </span>
            </li>
          </template>
        </span>
      </ul>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    currentGroupPermissions: {},
    simpleLayers: [],
    permissionsList: []
  }),
  computed: {
    currentGroupId() {
      return this.$store.getters.getCurrentUserGroup;
    },
    currentUsername() {
      return this.$store.getters.getCurrentUsername;
    }
  },
  methods: {
    loadUserPermissions() {
      const self = this;
      // get current user's group
      this.$store.dispatch("getPermissionsList").then(r => {
        if(r) {
          this.permissionsList = r.permissions;
          this.$store.dispatch("getUserGroup", this.currentGroupId).then(r => {
            if(r) {
              this.currentGroupPermissions = r.group.permissions;
              console.log(r.group.permissionsale)
            } else {
              self.$root.$emit(
                "showSnackbar",
                "red",
                "Błąd podczas pobierania grupy"
              );
            }
          });
        } else {
          self.$root.$emit("showSnackbar", "red", `${r}`);
        }
      });
    },
    getLayers() {
      const self = this;
      this.$store.dispatch("getSimpleLayers").then(res => {
        if(res) {
          self.simpleLayers = res;
        } else {
          self.$root.$emit("showSnackbar", "red", "Błąd pobierania warstw");
        }
      });
    },
    savePermissions() {
      const self = this;
      let payload = {
        groupid: this.currentGroupId,
        body: this.currentGroupPermissions
      };
      this.$store.dispatch("updateGroupPermissions", payload).then(res => {
        if(res) {
          self.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie dokonano edycji uprawnień"
          );
        } else {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Wystąpił błąd podczas edycji uprawnień"
          );
        }
      });
      this.$modal.hide("ModifyPermissions");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/settings/modals/userManagement/ModifyPermissions.vue